
import ModuleViewModal from "@/components/modal/ModuleViewModal";
import CooperationAddModal from "@/components/modal/CooperationAddModal";
import ImageViewModal from "@/components/modal/ImageViewModal";
import PartnersAddModal from "@/components/modal/PartnersAddModal";
import FormDetailModal from "@/components/modal/FormDetailModal";
import NewsSubscribeModal from "@/components/modal/NewsSubscribeModal";
import NewsSubscribeDetailModal from "@/components/modal/NewsSubscribeDetailModal";
import ExcelTermModal from "@/components/modal/ExcelTermModal";
import FooterModal from "@/components/modal/FooterModal";
import CooperationBrandOrderAddModal from "@/components/modal/CooperationBrandOrderAddModal";
import CooperationDetailModal from "@/components/modal/CooperationDetailModal";

export const MODAL_PAYLOAD = {
    MODULE_VIEW_MODAL: (data) => {
        return {
            modalProps: {
                width: 1280,
                title: `${data?.item?.title} 자세히 보기`,
                type: "MODAL",
                data: data,
                closeCustom: true,
            },
            component: ModuleViewModal
        }
    },
    COOPERATION_ADD_MODAL: (data, menuId, sub) => {
        return {
            modalProps: {
                width: 1000,
                height: "90vh",
                title: `협력회사 ${sub}`,
                type: "MODAL",
                data: data,
                menuId: menuId,
            },
            component: CooperationAddModal,
        }
    },
    PARTNERS_ADD_MODAL: (data, menuId, sub) => {
        return {
            modalProps: {
                width: 1000,
                height: "90vh",
                title: `파트너사 ${sub}`,
                type: "MODAL",
                data: data,
                menuId: menuId,
            },
            component: PartnersAddModal,
        }
    },
    IMAGE_VIEW_MODAL: (data) => {
        return {
            modalProps: {
                width: 500,
                height: "100%",
                maxHeight: "60vh",
                type: "MODAL",
                data: data,
            },
            component: ImageViewModal,
        }
    },
    FORM_DETAIL_MODAL: (data, name) => {
        return {
            modalProps: {
                width: 800,
                title: `${name} 상세`,
                height: "80vh",
                type: "MODAL",
                data: data,
            },
            component: FormDetailModal,
        }
    },



    NEWS_SUBSCRIBE_MODAL: (subType) => {
        return {
            modalProps: {
                width: 480,
                title: "뉴스레터 구독",
                type: "MODAL",
                subType: subType,
                homePageInner: true,
            },
            component: NewsSubscribeModal,
        }
    },


    COOPERATION_DETAIL_MODAL: (data) => {
        return {
            modalProps: {
                width: 480,
                height: "640px",
                moWidth: true,
                moHeight: true,
                type: "MODAL",
                data: data,
                closeCustom: true,
                homePageInner: true,
            },
            component: CooperationDetailModal,
        }
    },

    COOPERATION_BRAND_ODER_ADD_MODAL: {
        modalProps: {
            width: 600,
            height: "70vh",
            title: "발주일 등록",
            type: "MODAL",
        },
        component: CooperationBrandOrderAddModal
    },
    NEWS_SUBSCRIBE_DETAIL_MODAL: {
        modalProps: {
            width: 600,
            height: "70vh",
            title: "구독 내역",
            type: "MODAL",
        },
        component: NewsSubscribeDetailModal
    },
    EXCEL_TERM_MODAL: (id) => {
        return {
            modalProps: {
                width: 600,
                title: "신청 내역 기간 다운로드",
                type: "MODAL",
                visible: true,
                menuId: id
            },
            component: ExcelTermModal,
        }
    },
    FOOTER_MODAL: (name, data) => {
        return {
            modalProps: {
                width: 500,
                moWidth: true,
                height: "500px",
                moHeight: true,
                title: name,
                type: "MODAL",
                data: data,
            },
            component: FooterModal,
        }
    },
}

